<mat-toolbar [color]="toolbarColor">
    <div class="logo-container" routerLink="/">
        <a class="yi-logo"></a>
    </div>
    <!-- open menu -->
    <button class="sidenav-toggle mat-button" mat-button="" (click)="toggleMenu()">
        <mat-icon role="img" class="material-icons mat-icon" aria-label="menu">menu</mat-icon>
    </button>


    <!-- This fills the remaining space of the current row -->
    <span class="example-fill-remaining-space">{{ authDomain }}</span>

    <!-- <a routerLink="/" mat-button><mat-icon>settings</mat-icon>&nbsp;Settings</a> -->
    
    <!--
    <button mat-button="" mat-icon-button (click)="openNotifications()">
        <div class="new-notifications"></div>
        <mat-icon>notifications</mat-icon>     
    </button>
    -->
    
    <button mat-button [matMenuTriggerFor]="menu">
        <img *ngIf="loggedUserPhoto" class="avatar" [src]="loggedUserPhoto" alt="Avatar">
        <mat-icon *ngIf="!loggedUserPhoto" >person</mat-icon>&nbsp;{{ loggedUser }}
    </button>
    <mat-menu #menu="matMenu" yPosition="below" [overlapTrigger]="false">
        <button (click)="logoutUser()" mat-menu-item>
        <mat-icon>flight_land</mat-icon>
        <span i18n="Logut button">Logout</span>
        </button>
    </mat-menu>
</mat-toolbar>


// WEBPACK FOOTER //
// ./src/app/components/header.component.html